import { render } from "./OurTransaction.vue?vue&type=template&id=75d6093b&scoped=true"
import script from "./OurTransaction.vue?vue&type=script&lang=js"
export * from "./OurTransaction.vue?vue&type=script&lang=js"

import "./OurTransaction.vue?vue&type=style&index=0&id=75d6093b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d6093b"]])

export default __exports__